const REGION_NAMES =
  typeof Intl !== "undefined" && "DisplayNames" in Intl
    ? new Intl.DisplayNames(["en"], { type: "region" })
    : undefined;

export default function getCountryName(countryCode?: string): string {
  if (!countryCode) {
    return "";
  }

  const code = countryCode.toUpperCase();

  try {
    const localName = REGION_NAMES?.of(code);

    return localName ?? countryCode;
  } catch {
    return countryCode;
  }
}
